/* vue */
import Vue from 'vue';
import Meta from 'vue-meta';
// fast click
import FastClick from 'fastclick';
// 数据打点
import { YmReporterPlugin } from 'ym-reporter-vue';

/* directives */
import { Lazyload } from '@ymba/ym-ui';
import VueScrollTo from 'vue-scrollto';
import directives from '@/directives';

import store from '@/store';
import router from '@/router';

/* css */
import 'normalize.css';
import '@ymba/ym-ui/lib/index.css';
import 'swiper/dist/css/swiper.css'; // eslint-disable-line import/no-extraneous-dependencies

// import 'vw-layout';

/* plugins */
import Wechat from '@/plugins/wechat';
import Header from '@/plugins/header';
// 数据埋点配置
import REPORT_CONFIG from '../reporterrc';

/* filters */
import * as filters from '@/filters';

/* global */
import '@/common/components'; // components
import inputHandler from '@/common/input'; // input handler
// import Monitor from '@/common/monitor'; // error monitor

import App from '@/App';
import { getUID } from '@/utils';
// 版本号
const PACKAGE_VERSION = require('../package.json').version;

// 网络提示
require('@/common/net-info');

Object.keys(filters).forEach((key) => { // 全局注册 filters
  Vue.filter(key, filters[key]);
});

Object.keys(directives).forEach((key) => {
  Vue.directive(key, directives[key]);
});

Vue.use(Meta);

Vue.use(Wechat);
Vue.use(Header);
// 使用数据埋点
Vue.use(YmReporterPlugin, {
  type: 'ymReporter',
  host: process.env.VUE_APP_LOG_HOST_DEV,
  appKey: process.env.VUE_APP_LOG_APP_KEY_DEV,
  version: PACKAGE_VERSION,
  duration: process.env.VUE_APP_LOG_DURATION,
  cachePrefix: 'YMBAmw',
  autoReport: false,
  getUid: getUID,
  router,
}, REPORT_CONFIG);

Vue.use(Lazyload, {
  loading: require('@/assets/img/default/loading.gif'), // eslint-disable-line global-require
});
Vue.use(VueScrollTo);

const isProd = process.env.NODE_ENV === 'production';
const isProdPack = process.env.VUE_APP_PACK_MODE === 'production';
Vue.config.debug = !isProdPack;
Vue.config.devtools = !isProdPack;
Vue.config.productionTip = !isProdPack;
Vue.config.ignoredElements = ['wx-open-launch-app'];

// 错误监控
// if (isProd) {
//   Monitor.getInstance({
//     environment: process.env.VUE_APP_PACK_MODE,
//   });
// }

window.addEventListener('load', () => {
  // 页面加载时添加fast click监听
  FastClick.attach(document.body);

  if (isProd) {
    const log = async () => {
      const PMonitor = (await import('@/utils/performance')).default;
      new PMonitor();
    };

    // 尽量不影响页面主线程
    if (window.requestIdleCallback) {
      window.requestIdleCallback(log);
    } else {
      setTimeout(log);
    }
  }
});

// iOS 软键盘处理器
inputHandler();

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
